export default __webpack_public_path__ + "static/media/team53.c307e985.JPG";